import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { schoolfeesincreaselist } from './schoolfeesincreaserequestlist.service';
import { global } from '../../../shared/global';
declare var $: any;

@Component({
  selector: 'app-schoolfeesincreaserequestlist',
  templateUrl: './schoolfeesincreaserequestlist.component.html',
  styleUrls: ['./schoolfeesincreaserequestlist.component.css']
})
export class SchoolfeesincreaserequestlistComponent implements OnInit {
  @ViewChild('requestDetailModal') requestDetailModal: NgForm;
  SchoolFeesIncreaseList: Array<any>;
  SchoolFeesIncreaseDetail: Array<any>;
  p: number = 1;
  responseData: any;
  pageLimit = global.pageLimit;
  searchtext;
  isDesc: boolean;
  column: string;
  allowDelete: boolean = false;
  disabletextbox: boolean = false;
  totalFees:any;
  totalPages = 10;
  constructor(private service: schoolfeesincreaselist, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.getSchoolFeesIncreaseList(this.p);
});
    $("#searchtext").val("");
    this.getSchoolFeesIncreaseList(this.p);
  }

  getSchoolFeesIncreaseList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      yearID: localStorage.getItem("yearID"),
      HashCode: localStorage.getItem("HashCode"),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    };
  
    this.service.getSchoolFeesIncreaseList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.SchoolFeesIncreaseList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return;
        }
        else {
          this.spinner.show();
          this.SchoolFeesIncreaseList = this.responseData.SchoolFeesIncreaseList;
          this.totalFees = this.responseData.totalCount;
          this.spinner.hide();
          //this.getSchoolFeesIncreaseList();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  editRequest(HashCode) {
    this.router.navigate(['/schoolfeesincrease/' + HashCode]);
  }

  deleteRequest(HashCode) {
    if (confirm("Are you sure you want to delete ?")) {
      this.spinner.show();
      const data = {
        hashCode: HashCode,
      };
      this.service.deleteSchoolFeesIncreasMaster(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          } else {
            this.toastr.success(this.responseData.message);
            this.getSchoolFeesIncreaseList(this.p);
          }
        }, (err: HttpErrorResponse) => {
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.SchoolFeesIncreaseList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }

  addNew() {
    this.router.navigate(['/schoolfeesincrease']);
  }

  closeForm() {
    $('#requestDetailModal').modal('hide');
    this.getSchoolFeesIncreaseList(this.p);
  }
}
